// +route.ts
import type { PageContext } from 'vike/types';
import { extractCompanyProfileSlugFromUrlPathname } from '../../../utils/company/resolve-company-profile-route-slug';

/**
 * Route guard for company profile pages.
 *
 * The default single-segment `@companyslug` route can only ever match one path
 * segment, so it silently fails to match for legitimate companies whose display
 * name contains a literal "/" or "\" (e.g. "Astellas Pharma A/S, filial i
 * Finland") — something upstream (CDN/API Gateway) decodes the percent-encoded
 * slash before Vike's own route matching runs, splitting what should be one slug
 * into extra path segments. This explicitly reconstructs the full slug from the
 * raw pathname (rejoining any extra segments) so those pages resolve instead of
 * falling through to the generic 404, mirroring the job-detail route's own
 * `+route.ts` guard.
 */
export function route(pageContext: PageContext) {
  const pathToCheck = (pageContext as { urlLogical?: string; urlPathname?: string }).urlLogical
    ?? pageContext.urlPathname;

  if (!pathToCheck) {
    return false;
  }

  const slug = extractCompanyProfileSlugFromUrlPathname(pathToCheck);
  if (!slug) {
    return false;
  }

  return {
    routeParams: { companyslug: slug },
  };
}
